export default "__VITE_ASSET__9f719d7a__"